<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <v-app>
        <resizable-page>
          <template v-slot:table="tableProps">
            <v-card>
              <!-- <v-card-title>
                Client Master List
              </v-card-title> -->
              <v-card-title>
                
                  <v-btn
                        color="primary"
                        dark
                        class="ma-2"
                        @click="addPool"
                      
                      >
                        Add Eshed
                      </v-btn>
                  <!-- <v-menu>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      dark
                      class="ma-2"
                      v-bind="attrs"
                      v-on="on"
                    >
                      Export To XLS
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item>
                      <downloadExcel
                        :data="dataExport(table)"
                        :fields="field_export"
                        :worksheet="worksheetName"
                        :name="fileName"
                      >
                        All Record
                      </downloadExcel>
                    </v-list-item>
                    <v-list-item>
                      <downloadExcel
                        :data="exportDisplayedPage"
                        :fields="field_export"
                        :worksheet="worksheetName"
                        :name="fileName"
                      >
                        Displayed record
                      </downloadExcel>
                    </v-list-item>
                    <v-list-item>
                      <downloadExcel
                        :data="exportAllFitered"
                        :fields="field_export"
                        :worksheet="worksheetName"
                        :name="fileName"
                      >
                        All filtered record
                      </downloadExcel>
                    </v-list-item>
                  </v-list>
                </v-menu> -->
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-data-table
                mobile-breakpoint
                :headers="headers"
                :items="table"
                :search="search"
                :loading="loadTable"
                loading-text="Loading... Please wait"
                
                ref="vTable"
                :height="tableProps.tableHeight"
                fixed-header
                :footer-props="{'items-per-page-options':[5,15, 30, 50, 100, -1]}"
                :options="{'itemsPerPage':10}"
              >
              
              <template  v-slot:[`item.pool_head_id`]="{ item }">
                {{ item.pool_head.name }}
              </template>

              <template  v-slot:[`item.pool_workshop_head_id`]="{ item }">
                {{ item.workshop_head.name }}
              </template>

              <template v-slot:[`item.actions`]="{ item }">
                
                  <v-menu  offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      dark
                      x-small
                      v-bind="attrs"
                      v-on="on"
                      
                    >
                      <v-icon dark x-small>
                        mdi-format-list-bulleted-square
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item  @click="editPool(item.id)">
                      <v-list-item-title x-small>Edit</v-list-item-title>
                    </v-list-item>
                    <!-- <v-list-item  @click="deleteConfirmation(item.id)">
                      <v-list-item-title >Delete</v-list-item-title>
                    </v-list-item> -->
                  </v-list>
                </v-menu>
              </template>
              
              </v-data-table>
            </v-card>
          </template>
        </resizable-page>
      </v-app>
      <modal ref="modalAddPage">
        <template v-slot:header>
          <div style="text-align:center; margin:auto;">
            <h3>Add Eshed</h3>
          </div>
          <md-button
            class="md-icon-button md-dense md-round"
            @click="modalCloseAdd()"
          >
            <md-icon>close</md-icon>
          </md-button>
        </template>
        <template v-slot:body>
          <add-pool />
        </template>
      </modal>
      <modal ref="modalEditPage">
        <template v-slot:header>
          <div style="text-align:center; margin:auto;">
            <h3>Edit Eshed</h3>
          </div>
          <md-button
            class="md-icon-button md-dense md-round"
            @click="modalCloseEdit()"
          >
            <md-icon>close</md-icon>
          </md-button>
        </template>
        <template v-slot:body >
          <edit-pool :data_id="$refs.modalEditPage.data"/>
        </template>
      </modal>
    </div>
  </div>
</template>

<script>
import vuetify from '@/plugins/vuetify'
import { ResizablePage } from "@/components";
import Vue from "vue";
import addPool from "@/pages/Dashboard/Workshop/Eshed/AddPPage.vue";
import editPool from "@/pages/Dashboard/Workshop/Eshed/EditPPage.vue";
import { Modal } from "@/components";
import VueSweetalert2 from "vue-sweetalert2";
// import Swal from "sweetalert2";
// import JsonExcel from "vue-json-excel";


Vue.use(VueSweetalert2);

export default {
  components: {
    // downloadExcel: JsonExcel,
    ResizablePage,
    Modal,
    "add-pool": addPool,
    "edit-pool": editPool
  },
  vuetify,
  data: () => ({
    loadTable: true,
        role: "",
        search: '',
        headers: [
          { text: 'Actions', value: 'actions', align: 'start', sortable: false },
          {
            text: 'Eshed Name',
            align: 'center',
            value: 'pool_name',
          },
          { text: 'Eshed Head', value: 'pool_head_id', align: 'center' },
          { text: 'Workshop Head', value: 'pool_workshop_head_id', align: 'center' },
        ],
        table: [],
    //     worksheetName: "Eshed",
    //     fileName:"Eshed.xls",
    //     exportDisplayedPage:[],
    //     exportAllFitered:[],
    //     field_export: {
    //       'business_unit_name': 'business_unit_name',
    //       'business_unit_remark': 'business_unit_remark'
                    
    // },
  }),


  created() {
    this.getList();
  },

  methods: {
    // ambil data yang dibutuhkan
    async getList() {
      //get list role dan permission current user 
      this.role = await this.$store.getters["role_permission/route_filter"];
      await this.$store.dispatch("workshop_pool/list");

      if (
        (await this.$store.getters["workshop_pool/list"]) &&
        (await this.$store.getters["workshop_pool/list"].length) != 0
      ) {
        this.table = await this.$store.getters["workshop_pool/list"];
      }
      this.loadTable= false
    },

    // getFiltered(data){
    // this.exportDisplayedPage = this.dataExport(data)
    // if(this.$refs.vTable){
    //   this.exportAllFitered = this.dataExport(this.$refs.vTable.$children[0].filteredItems)
    // }
    // else{
    //   this.exportAllFitered = this.dataExport(this.table)
    // }
    // },


    // fungsi add data
    addPool() {
      // panggil add page
      this.$refs.modalAddPage.openModal();
    },

    modalCloseAdd(){
      this.$refs.modalAddPage.closeModal();
      this.getList();
    },

    // fungsi edit data
    editPool(id) {
      // panggil edit page
      this.$refs.modalEditPage.openModal({ id: id });
    },

    modalCloseEdit(){
      this.$refs.modalEditPage.closeModal();
      this.getList();
    },

    // validasi delete data
    // deleteConfirmation(id) {
    //   Swal.fire({
    //     title: "Are you sure?",
    //     text: "You wont be able to revert this!",
    //     icon: "warning",
    //     showCancelButton: true,
    //     confirmButtonColor: "#3085d6",
    //     cancelButtonColor: "#d33",
    //     confirmButtonText: "Yes, delete it!",
    //     cancelButtonText: "No, cancel!",
    //     buttonsStyling: true,
    //   }).then((result) => {
    //     if (result.value) {
    //       this.deleteVehicle(id);
    //     }
    //   });
    // },

    // fungsi delete data 
    // async deleteVehicle(id) {
    //   try {
    //     // kirim data ke api
    //     await this.$store.dispatch("workshop_pool/destroy", id);
    //     // panggil alert success
    //     await this.$store.dispatch(
    //       "alerts/success",
    //       "Business Unit data delete successfully."
    //     );
    //     //await this.getList();
    //     var indexOptionTable = this.table.findIndex(p => p.id ==  id)
    //       var indexOptionTablePage = this.tablePage.findIndex(p => p.id ==  id)
    //        this.table.splice(indexOptionTable, 1)
    //        this.tablePage.splice(indexOptionTablePage, 1)
    //        this.total = this.table.length
    //        this.dataExport(this.table, "all");
    //       this.dataExport(this.table, "filter");
    //       this.dataExport(this.tablePage, "page");
    //   } catch (e) {
    //     // panggil alert error
    //     await this.$store.dispatch(
    //       "alerts/error",
    //       "Oops, something went wrong!"
    //     );
    //     this.setApiValidation(e.response.data.errors);
    //   }
    // },

    //fungsi untuk mengubah data yang siap di export data ke xls, saat dipanggil di awal dan dipanggil berulang kali di fungsi filter
    // dataExport(data, jenis) {
    //   data = data.map((v, index) => ({ ...v, no: index + 1 }));
    //   if (jenis == "all") {
    //     this.dataExsport = [];
    //     this.dataExsport = data;
    //   } else if (jenis == "filter") {
    //     this.dataExsportFilter = [];
    //     this.dataExsportFilter = data;
    //   } else if (jenis == "page") {
    //     this.dataExsportPage = [];
    //     this.dataExsportPage = data;
    //   }
    //   // console.log(data)
    // },
  },
};
</script>
<style>
#pro-feature {
  font-weight: bold;
}
</style>
